import React from "react";
import { Dropdown, Badge } from "react-bootstrap";
import { FileEntry, FolderEntry } from "./filebase";
import { FileDrive_Funcs } from "./filedriveFuncs";

type CustomToggleProps = {
    onClick: (...arg: any[]) => void;
    faName: string;
    style?: React.CSSProperties;
}
const CustomToggle = React.forwardRef<HTMLInputElement, CustomToggleProps>(
    (props, ref) => (
        <i className={props.faName}
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                props.onClick(e);
            }}
            style={(props.style === undefined) ? {} : props.style}>
        </i>
    ))
    
type FolderRowProps = {
    folder: FolderEntry;
    renameF: ({ }: { show: boolean, folder?: FolderEntry, doc?: FileEntry }) => void;
    deleteF: ({ }: { show: boolean, folder?: FolderEntry, doc?: FileEntry }) => void;
}
const FolderRow: React.FC<FolderRowProps> = ({
    folder,
    renameF,
    deleteF
}: FolderRowProps) => (
    <tr onClick={() => { FileDrive_Funcs.getFolder(folder.name); }}>
        <td>
            <i className="fa-solid fa-folder"></i>
        </td>

        <td>{folder.name}</td>

        <td></td>

        <td>
            <Badge bg="secondary" text="dark" pill style={{whiteSpace:"break-spaces"}}>{FileDrive_Funcs.printDateFromNow(folder)}</Badge>
        </td>

        <td className="align-right" onClick={(e) => { e.stopPropagation() }}>
            <Dropdown drop='start' className="options dropdown">
                <Dropdown.Toggle as={CustomToggle} faName="fa-regular fa-ellipsis-vertical" />
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => {
                        renameF({ show: true, folder: folder });
                    }}>
                        Rename
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => {
                        deleteF({ show: true, folder: folder });
                    }}>
                        Delete
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </td>
    </tr>
)

export default FolderRow;